import { makeAutoObservable } from 'mobx'
import { toJS } from 'mobx'

import { IPopularRoutesAvia, MainPageAvia } from 'shared/api/avia/main-page'
import {
  IPopularDirectionsAvia,
  PopularDirectionsAvia,
} from 'shared/api/avia/popular-directions'

class PopularDirectionStore {
  popularDirections: IPopularRoutesAvia[] | null = null
  popularDirectionsList: IPopularDirectionsAvia[] | null = null

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  async fetchPopularDirections() {
    try {
      const { data } = await MainPageAvia.getPopularRoutes()
      this.setPopularDirections(data.data)

      return toJS(this.getPopularDirections())
    } catch (error) {
      console.error('Failed to fetch popular directions:', error)
    }
  }

  setPopularDirections(data: IPopularRoutesAvia[] | null) {
    this.popularDirections = data
  }

  getPopularDirections() {
    return toJS(this.popularDirections)
  }

  async fetchPopularDirectionsList() {
    try {
      const { data } = await PopularDirectionsAvia.getPopularDestinations()
      this.setPopularDirectionsList(data.data)

      return toJS(this.getPopularDirectionsList())
    } catch (error) {
      console.error('Failed to fetch popular directions:', error)
    }
  }

  setPopularDirectionsList(data: IPopularDirectionsAvia[] | null) {
    this.popularDirectionsList = data
  }

  getPopularDirectionsList() {
    return toJS(this.popularDirectionsList)
  }
}

export const popularDirectionAviaStore = new PopularDirectionStore()
